<template>
  <div id="chart">
    <GChart
      :settings="{ packages: ['corechart', 'bar']}"
      type="ColumnChart"
      :data="chartData"
      :options="chartOptions"
      style="width: 650px; height: 300px;"
      @ready="onChartReady"
      ref="gChart"
    />
  </div>
</template>

<script>

    import { GChart } from "vue-google-charts";

    export default {
      name: "BarThree2017",
      components: {
        GChart
      },
      props: {
        mydata : []
      },
      data() {
          return {
              chartData: this.mydata,
              chartOptions: {
                title: 'Year 2017',
                hAxis: {
                  minValue: 0,
                },
                vAxis: {
                  title: 'Variables'
                },
                colors: ['#D6F1FF','#9ae2ff', '#42C0FB'],
                width: 650,
                height: 300
              },
              month: '',
              methods : '',
              pragmatics: '',
              aesthetics: '',
          }
        },
        methods: {
          onChartReady(chart, google) {
            // now we have google lib loaded. Let's create data table based using it.
            this.createDataTable(chart, google);
          },
          createDataTable(chart, google) {

            var data = new google.visualization.DataTable();
            data.addColumn('string', 'Month');
            data.addColumn('number', 'Method');
            data.addColumn('number', 'Pragmatics');
            data.addColumn('number', 'Aesthetics');

            let rows = [];
            let count = 0;

            for(let index in this.chartData){
              if(this.chartData.hasOwnProperty(index)){
                  if(this.chartData[index].date === '2017'){
                  this.month = this.chartData[index].month;
                  this.methods = this.chartData[index].methods;
                  this.pragmatics = this.chartData[index].pragmatics;
                  this.aesthetics = this.chartData[index].aesthetics;

                  rows[count] = [];
                  rows[count][0] = this.month;
                  rows[count][1] = this.methods;
                  rows[count][2] = this.pragmatics;
                  rows[count][3] = this.aesthetics;

                  count++;
                }
              }
            }
            data.addRows(rows);

            var view = new google.visualization.DataView(data);
            chart.draw(view, this.chartOptions);
          }
      },
      mounted()  {
        console.log('bar three 2017 loaded');
      }
    }
</script>

<style scoped>

  #chart {
    width: 650px;
    height: 300px;
  }

</style>
